import {
    ISimplePresentation,
    ISimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {KennethMustDie} from "../KennethMustDie";

export class KMDBigWinRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return KennethMustDie.model.isBigWin;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        KennethMustDie.bigWin.playBigWin(controller);
    }
}